import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Typography,
} from '@mui/material';
import { CustomButton, CustomTextField, CustomCheckbox } from '../../../../../common/components';
import { isBooleanActive } from '../../../utils/contractsUtils';

const SubscriberDialog = ({
  subscriberDialogOpen,
  editModeSubscriber,
  selectedSubscriber,
  matchingSubscribers,
  handleCloseSubscriberDialog,
  handleInputChangeSubscriber,
  handleInputChangeDNISubscriber,
  handleSubscriberSelection,
  handleSaveSubscriber,
}) => {
  return (
    <Dialog open={subscriberDialogOpen} onClose={handleCloseSubscriberDialog} maxWidth={false}>
      <Box sx={{ p: 2, borderBottom: '2px solid #5e894f', backgroundColor: '#f2f2f2' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#5e894f', textAlign: 'center' }}>
          {editModeSubscriber ? 'EDITAR SUSCRIPTOR' : 'AGREGAR SUSCRIPTOR'}
        </Typography>
      </Box>

      <DialogContent sx={{ display: 'flex' }}>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Box sx={{ width: '300px' }}>
            {!editModeSubscriber ? (
              <Autocomplete
                options={matchingSubscribers}
                getOptionLabel={(subscriber) =>
                  `(${subscriber.dni}) ${subscriber.last_name}, ${subscriber.first_name}`
                }
                renderInput={(params) => (
                  <CustomTextField
                    {...params}
                    disabled={editModeSubscriber}
                    margin="dense"
                    name="dni"
                    label="DNI"
                    fullWidth
                    value={selectedSubscriber.subscriber?.dni || ''}
                    onChange={handleInputChangeDNISubscriber}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password',
                    }}
                  />
                )}
                onChange={(event, value) => handleSubscriberSelection(value)}
              />
            ) : (
              <CustomTextField
                disabled={editModeSubscriber}
                margin="dense"
                name="dni"
                label="DNI"
                fullWidth
                value={selectedSubscriber.subscriber?.dni || ''}
              />
            )}
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre"
              fullWidth
              disabled
              value={
                selectedSubscriber.subscriber
                  ? `${selectedSubscriber.subscriber.last_name}, ${selectedSubscriber.subscriber.first_name}`
                  : ''
              }
            />
            <CustomTextField
              margin="dense"
              name="life_insurance_percentage"
              label="Seguro de Vida (%)"
              type="number"
              fullWidth
              value={selectedSubscriber.life_insurance_percentage ?? 0}
              onChange={handleInputChangeSubscriber}
            />
          </Box>

          <Box sx={{ width: '20px' }} />

          <Box sx={{ width: '300px' }}>
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={isBooleanActive(selectedSubscriber.social_fee_payment)}
                  onChange={(e) =>
                    handleInputChangeSubscriber({
                      target: { name: 'social_fee_payment', value: e.target.checked },
                    })
                  }
                />
              }
              label="Paga Cuota Social"
              sx={{
                mt: '8px',
                border: '1px solid #c6c7c5',
                borderRadius: '4px',
                width: '100%',
                padding: '6px',
                display: 'flex',
                paddingLeft: '60px',
              }}
            />
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={isBooleanActive(selectedSubscriber.postage_address)}
                  onChange={(e) =>
                    handleInputChangeSubscriber({
                      target: { name: 'postage_address', value: e.target.checked },
                    })
                  }
                />
              }
              label="Dirección Franqueo"
              sx={{
                mt: '12px',
                border: '1px solid #c6c7c5',
                borderRadius: '4px',
                width: '100%',
                padding: '6px',
                display: 'flex',
                paddingLeft: '60px',
              }}
            />
            <FormControlLabel
              control={
                <CustomCheckbox
                  checked={isBooleanActive(selectedSubscriber.mail_coupon)}
                  onChange={(e) =>
                    handleInputChangeSubscriber({
                      target: { name: 'mail_coupon', value: e.target.checked },
                    })
                  }
                />
              }
              label="Cupón por mail"
              sx={{
                mt: '12px',
                border: '1px solid #c6c7c5',
                borderRadius: '4px',
                width: '100%',
                padding: '6px',
                display: 'flex',
                paddingLeft: '60px',
              }}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
        <CustomButton onClick={handleCloseSubscriberDialog} variant="text">
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleSaveSubscriber} variant="contained">
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default SubscriberDialog;
